export const DATA_ROWS = 4;
export const SHIPMENT_DATA_DEFAULT: number[][] = Array(DATA_ROWS)
  .fill(0)
  .map((_) => Array(17).fill(0));

export const CUP_DATA_DEFAULT: number[][] = Array(5)
  .fill(0)
  .map((_) => Array(15).fill(0));

export const TOTAL_UNITS_ACCESSOR = 12;

const SHIPMENT_SUBMIT_URI = "/v1/shipment-submit";

export const FORECAST_URI = `${SHIPMENT_SUBMIT_URI}/forecast`;
const SEASON_TO_MONTH_URI = `${SHIPMENT_SUBMIT_URI}/season-to-month`;
export const SHIPMENT_HISTORY_URI = `${SEASON_TO_MONTH_URI}/shipment-history`;
export const CUP_UNITS_URI = `${SEASON_TO_MONTH_URI}/cup-total-units`;
export const AT_ONCE_URI = `${SHIPMENT_SUBMIT_URI}/at-once`;
export const DISTRIBUTION_URI = `${SHIPMENT_SUBMIT_URI}/distribution-method`;
export const CCD_SHORT_RANGE = `${SHIPMENT_SUBMIT_URI}/ccd-shipment/short-range`;
export const CCD_LONG_RANGE = `${SHIPMENT_SUBMIT_URI}/ccd-month/long-range`;
